module.exports = __webpack_public_path__ + "static/fonts/siyuanH.4abbfb4.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/siyuanH.otf
// module id = dbAB
// module chunks = 1